import React from "react";
import '@deere/ux.uxframe-core/dist/css/uxframe-2019.3.0.min.css';
import { Modal } from '@deere/ux.uxframe-react';
import Button from "../../reusable/components/Button.jsx";
import { isMobile } from 'react-device-detect';

if (isMobile) {
  import('../../mobileindex.css').then(() => {});
} else {
  import('../components/scss/index.css').then(() => {});
}

class Agreement extends React.Component {
  handleShow = () => {
    this.props.showModal();
  }

  handleClick = () => {
    this.props.showButton();
  }

  handleWindow = () => {
    window.open("https://investor.deere.com/governance/default.aspx#_ctrl0_ctl78_divModuleContainer", "Popup", "location,status,scrollbars,resizable,width=800, height=800");
    this.handleClick();
  }

  render() {
    return (
      <div>
        <Modal size='md' show={this.props.show}>
          <Modal.Body>
            <p class="uxf-alert-title">
              To ensure that all of our suppliers conduct business with a high degree of integrity and in a socially and environmentally responsible manner, we hold them to the John Deere Supplier Code of Conduct.<br /><br />
            </p>
            <div className="text-center" style={{ padding: '10px' }}>
              <h6><span className="border border-default" style={{ padding: '10px' }}>
                <a className="text-decoration-none" href="" onClick={this.handleWindow} target="_new">&nbsp;&nbsp;View Supplier Code Of Conduct&nbsp;&nbsp;</a>
              </span></h6>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button type="secondary"
              action={() => { document.location.href = "supplier-details/decline" }}
              title={"Decline"}>
            </Button>&nbsp;&nbsp;
            <Button disabled={this.props.toggleOn} type="warning"
              action={() => { document.location.href = "supplier-details/agree" }}
              title={"Accept"}>
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
export default Agreement;